import { handleResponse } from './apiUtil';
import http from './http-common';

export const getAll = () => http.get('/tracking/all').then(handleResponse);
export const get = (id) => http.get(`/tracking/${id}`).then(handleResponse);
export const register = (data) =>
    http.post('/tracking/create',data).then(handleResponse);
export const update = (id, data) =>
    http.put(`/tracking/update/${id}`, data).then(handleResponse);
export const remove = (id) =>
    http.delete(`/tracking/delete/${id}`).then(handleResponse);
